import React from "react";

import { CBreadcrumb, CBreadcrumbItem, CLink } from "@coreui/react";
import { useSelector } from "react-redux";

const Breadcrumb = ({ items = [], current, className }) => {
  const routes = useSelector(state => state.general.routes);

  return (
    <CBreadcrumb className={`w-100 p-0 border-0 ${className || ""}`}>
      <CBreadcrumbItem>
        <CLink to="/dashboard">Menu Inicial</CLink>
      </CBreadcrumbItem>
      {items.map((item, index) => {
        const possibleRoutes = routes.filter(
          route => route.path === item?.path
        );
        const route =
          possibleRoutes.length > 1
            ? possibleRoutes.find(route => route.url === item?.to)
            : possibleRoutes[0];

        // Usar o nome fornecido no item ou buscar nas rotas
        const displayName = item?.name || route?.name || "...";

        return (
          <CBreadcrumbItem key={index}>
            <CLink to={item?.to}>{displayName}</CLink>
          </CBreadcrumbItem>
        );
      })}
      <CBreadcrumbItem active>
        <span>
          {routes.find(route => route.id === parseInt(current))?.name ||
            "Página atual"}
        </span>
      </CBreadcrumbItem>
    </CBreadcrumb>
  );
};

export default Breadcrumb;
